import { Input, Directive } from '@angular/core';
import { TimezoneService, LocaleService, FormComponent } from '@tdwb/core';

export class AgreementsBase {
  language: string;

  constructor(localeService: LocaleService) {
    this.language = localeService.getLanguage();
  }
}

@Directive()
export class AgreementsDateBaseDirective extends AgreementsBase {
  @Input() disabled: boolean;
  @Input() consolidateAgreement?: boolean = false;

  selectedAgreementEffectiveDate: Date;

  constructor(timezoneService: TimezoneService, localeService: LocaleService) {
    super(localeService);
    this.selectedAgreementEffectiveDate = timezoneService.getCurrentDateInServerTimezone();
  }

  trySubmit(form: FormComponent): boolean {
    form.maybeSubmitForm();
    return !form.formElement.invalid;
  }
}
